import React from "react"
import { Form } from "react-bootstrap"
import { localize } from "services/base"
import { lang_json } from "signals/base"
import { changeFormData } from "signals/form"

const FormRadio = (props) => {
	const t = (key) => localize(key);
    const optionRadio = [
        {label:`txt_yes`,value:1},
        {label:`txt_no`,value:0},
    ]
	const { type, name, value, required, disabled, invalid, feedback } = props;

    const renderFeedback = () =>{
        return (
            <Form.Control.Feedback type="invalid">
                {lang_json.value[`error_${name}`]
                    ? t(`error_${name}`)
                    : t(`${name}`) + " " + t("error_not_valid")}
            </Form.Control.Feedback>
        )
    }

    const handleChange = (val) =>{
        changeFormData(name,val)
    }
	return (
        <Form.Group className="mb-3" controlId={name}>
			<Form.Label className={`fw-bold`}>
				{t(`${name}`)}
				{required && <span className="text-danger"> *</span>}
			</Form.Label>
            <Form.Control
                hidden
				type={`input`}
				required={required}
                name={name}
				value={value}
                isInvalid={invalid}
			/>
			<Form.Group controlId={name}>
                {optionRadio.map((data,x)=>
                    <Form.Check
                        key={x} 
                        inline
                        required={required}
                        disabled={disabled}
                        type={type} 
                        id={data.label}
                        label={t(data.label)}
                        onChange={()=>handleChange(data.value)}
                        checked={value === data?.value}
                        isInvalid={invalid}
                    >
                    </Form.Check>
                )}
            </Form.Group>
            {(feedback) && renderFeedback()}
		</Form.Group>
	)
}

export default FormRadio
